const foundersSlider = new Swiper('.founders-slider', {
  slidesPerView: 1,
  loop: false,
  allowTouchMove: true,
  spaceBetween: 20,
  watchOverflow: true,
  pagination: {
    el: '.founders .swiper-pagination',
    type: 'fraction',
  },
  navigation: {
    nextEl: '.founders .swiper-button-next',
    prevEl: '.founders .swiper-button-prev',
  },
  breakpoints: {
    767: {
      slidesPerView: 2.5,
      allowTouchMove: true,
      spaceBetween: 0,
    },
    1024: {
  slidesPerView: 3,
  allowTouchMove: true,
  spaceBetween: 0,
}
  }
});